module.exports = __webpack_public_path__ + "img/a-1.74d93d45.png";